/* レイアウト用論理棚 */
import React from 'react';
var LayoutDivision = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "layout-division" }, children);
};
export default LayoutDivision;
